"use strict";

var _slicedToArray = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @module index
 */

var transactions_1 = require("../transactions");

var marshall_1 = require("@waves/marshall");

var ts_lib_crypto_1 = require("@waves/ts-lib-crypto");

var generic_1 = require("../generic");

var validators_1 = require("../validators");

function cancelLease(paramsOrTx, seed) {
  var type = transactions_1.TRANSACTION_TYPE.CANCEL_LEASE;
  var version = paramsOrTx.version || 2;
  var seedsAndIndexes = generic_1.convertToPairs(seed);
  var senderPublicKey = generic_1.getSenderPublicKey(seedsAndIndexes, paramsOrTx);
  var tx = {
    type: type,
    version: version,
    senderPublicKey: senderPublicKey,
    leaseId: paramsOrTx.leaseId,
    fee: generic_1.fee(paramsOrTx, 100000),
    timestamp: paramsOrTx.timestamp || Date.now(),
    chainId: generic_1.networkByte(paramsOrTx.chainId, 87),
    proofs: paramsOrTx.proofs || [],
    id: ''
  };
  validators_1.validate.cancelLease(tx);
  var bytes = marshall_1.binary.serializeTx(tx);
  seedsAndIndexes.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        s = _ref2[0],
        i = _ref2[1];

    return generic_1.addProof(tx, ts_lib_crypto_1.signBytes(s, bytes), i);
  });
  tx.id = ts_lib_crypto_1.base58Encode(ts_lib_crypto_1.blake2b(bytes));
  return tx;
}

exports.cancelLease = cancelLease;